import { useState } from "react";
import { Loading } from "../../componentes/loading/loading";
import { useAssinatura } from "../../hooks/meuUsuario/useAssinatura";
import Button from "../../componentes/button/button";
import AssinaturaCanvas from "./AssinaturaCanvas";
import UploadAssinatura from "./UploadAssinatura";
import PreviewAssinatura from "./PreviewAssinatura";

const MODOS = [
    { label: "Desenhar", value: "desenhar", icon: "fa fa-pen" },
    { label: "Importar Imagem", value: "importar", icon: "fa fa-image" },
];

export default function AssinaturaCard() {
    const { imagemUrl, loading, salvando, excluindo, salvar, excluir } = useAssinatura();
    const [modo, setModo] = useState("desenhar");

    if (loading) {
        return <Loading label="Carregando assinatura..." />;
    }

    return (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 pt-2">
            <div className="flex flex-col gap-4">
                <div className="flex gap-2">
                    {MODOS.map(m => (
                        <Button
                            key={m.value}
                            variant={modo === m.value ? "blue" : "outline"}
                            label={m.label}
                            iconLeft={m.icon}
                            onClick={() => setModo(m.value)}
                        />
                    ))}
                </div>

                {modo === "desenhar"
                    ? <AssinaturaCanvas onSalvar={salvar} salvando={salvando} />
                    : <UploadAssinatura onSalvar={salvar} salvando={salvando} />
                }
            </div>

            <PreviewAssinatura imagemUrl={imagemUrl} onExcluir={excluir} excluindo={excluindo} />
        </div>
    );
}
